import { format } from "date-fns";

export interface SolicitudProyectoCabDTO {
    iddecinvproyecto: number,
    iddecinvproyectosolicitud: number,
    titulo: string,
    fechainicio: Date,
    fechafin: Date,
    codigo: string,
    director: string,
    estadoProy: string,
    estadoSolicitud: string,
    tipoSolicitud: string,
    tipoSolicitudTexto: string,
    respuesta: string,
    justificacion: string,
    fechaAmpliacion: Date
}

export function InitialSolicitudProyectoCabDTO(): SolicitudProyectoCabDTO {
    const fecha = new Date();
    return {
        iddecinvproyecto: 0,
        iddecinvproyectosolicitud: 0,
        titulo: "",
        fechainicio: fecha,
        fechafin: fecha,
        codigo: "",
        director: "",
        estadoProy: "",
        estadoSolicitud: "",
        tipoSolicitud: "",
        tipoSolicitudTexto: "",
        respuesta: "",
        justificacion: "",
        fechaAmpliacion: fecha,
    }
}

export function setSolicitudProyectoCabDTO(data: any): SolicitudProyectoCabDTO {
    const fecha = new Date();
    return {
        iddecinvproyecto: data.iddecinvproyecto??0,
        iddecinvproyectosolicitud: data.iddecinvproyectosolicitud??0,
        titulo: data.titulo??"",
        fechainicio: data.fechainicio??fecha,
        fechafin: data.fechafin??fecha,
        codigo: data.codigo??"",
        director: data.director??"",
        estadoProy: data.estadoProy??"",
        estadoSolicitud: data.estadoSolicitud??"",
        tipoSolicitud: data.tipoSolicitud??"",
        tipoSolicitudTexto: data.tipoSolicitudTexto??"",
        respuesta: data.respuesta??"",
        justificacion: data.justificacion??"",
        fechaAmpliacion: data.fechaAmpliacion??fecha,
    }
}